import { onMounted, onUnmounted } from "vue";

export function useWindowListeners(opts: {
    onScroll?: (e: Event) => void,
    onResize?: (e: Event) => void,
    onWheel?: (e: WheelEvent) => void, // Not in use: Save if manipulate timeline with wheel
    onTouchMove?: (e: TouchEvent) => void,  // Not in use: Save if manipulate timeline with touchmove
    passiveWheel?: boolean, // default true
}) {
    onMounted(() => {
        if (opts.onScroll) { window.addEventListener("scroll", opts.onScroll, { passive: true }); }
        if (opts.onResize) { window.addEventListener("resize", opts.onResize); }
        if (opts.onWheel) { 
            window.addEventListener("wheel", opts.onWheel, { passive: opts.passiveWheel ?? true }); }
        if (opts.onTouchMove) { 
            window.addEventListener("touchmove", opts.onTouchMove, { passive: true }); }
    });

    onUnmounted(() => {
        if (opts.onScroll) { window.removeEventListener("scroll", opts.onScroll as any); }
        if (opts.onResize) { window.removeEventListener("resize", opts.onResize as any); }
        if (opts.onWheel) { window.removeEventListener("wheel", opts.onWheel as any); }
        if (opts.onTouchMove) { window.removeEventListener("touchmove", opts.onTouchMove as any); }
    });
}
